const headerMenus = document.querySelectorAll('header-menu');

headerMenus.forEach(function(menu) {
  const detailsElements = menu.querySelectorAll('details');

  detailsElements.forEach(function(details) {
    let openTimeoutId;
    let closeTimeoutId;

    details.addEventListener('mouseenter', function() {
      clearTimeout(closeTimeoutId); // Cancel any close timers
      openTimeoutId = setTimeout(function() {
        details.open = true;
      }, 200); // Open only after 200ms hover
    });

    details.addEventListener('mouseleave', function() {
      clearTimeout(openTimeoutId); // Cancel opening if not yet opened
      closeTimeoutId = setTimeout(function() {
        details.open = false;
      }, 300); // Delay closing a bit to avoid flicker
    });
  });
});
